import DOMPurify from "dompurify";

// Sanitize article/preview HTML before rendering with dangerouslySetInnerHTML.
export const sanitizeHtml = (html) =>
  DOMPurify.sanitize(html || "", { USE_PROFILES: { html: true } });
